<template>
  <lb-drawer v-model="localFaqDialog"
    heading="Frequently Asked Question"
    Maxwidth="50%"
    :loading="loading"
    :sidePeekDefault="true"
    :hideMenu="true"
    data-testid="materiality-faq__drawer">
    <template v-slot:body>
      <div class="d-flex flex-column gap-2">
        <!-- Q1 -->
        <h6 class="font-weight-medium">
          What is Access Management? How can I update this?
        </h6>
        <span class="faqAnswer">
          Access Management helps in assigning roles to users for a specific
          {{ $nova.labelsName('materiality_page','unit_label','reporting unit').toLowerCase() }}.
          For a detailed explanation and step-by-step instructions, please refer to the
          "Access Management" section in the User Manual.
        </span>

        <!-- Q2 -->
        <h6 class="font-weight-medium">
          How do I check my role and
          {{ $nova.labelsName('materiality_page','unit_label','reporting unit').toLowerCase() }}?
          Why can’t I perform any action in the tool, and what should I do if I have
          not been assigned roles or have “View Only” access?
        </h6>
        <div class=" ">
          <ol>
            <li>
              Verify whether the user has access to the
              {{ $nova.labelsName('materiality_page','unit_label','reporting unit').toLowerCase() }}
              as per BFC, which drives role allocation in the Starlight application.
              Refresh the screen and try again after 5 minutes.
            </li>
            <li>Reach out to the Tool Admin Preparer to assign the required roles.</li>
            <li>Reach out to the Tool Admin Approver to approve the assigned roles.</li>
            <li>
              If the issue persists, contact the Consark Support Team with issue details
              and a screenshot (if available).
            </li>
          </ol>
        </div>

        <!-- Q3 -->
        <h6 class="font-weight-medium">
          What should I do if I encounter an error during a
          {{ $nova.labelsName('access_management','commentary_bulk_level_ru_upload_label_tooltip','Bulk RU level upload') }}
          or if I receive a “User ID not found” error?
        </h6>
        <div class="faqAnswer">
          <ol>
            <li>Ensure that all entered email IDs are in lowercase.</li>
            <li>Refresh the screen and try again after 10 minutes.</li>
            <li>
              If the issue persists, contact the Consark Support Team with issue details
              and a screenshot (if available).
            </li>
          </ol>
        </div>

        <!-- Q4 -->
        <h6 class="font-weight-medium">
          What should I do if I am unable to add or remove users, or if I need to remove user assignments?
        </h6>
        <div class="faqAnswer">
          <ol>
            <li>
              <ol type="a">
                <li>Refresh the screen and try again after 5 minutes.</li>
                <li>
                  If the issue persists, contact the Consark Support Team with issue details
                  and a screenshot (if available).
                </li>
                <li>
                  In case of user removal, confirmation from the Tool Admin Approver must
                  be received, after which the update will be reflected.
                </li>
              </ol>
            </li>
            <li>
              Tool Admin Approver rejection is the only way to reverse the change.
            </li>
          </ol>
        </div>

        <!-- Q5 -->
        <h6 class="font-weight-medium">
          Can I add users to multiple
          {{ $nova.labelsName('materiality_page','ru_entity_plural_label','reporting units').toLowerCase() }}
          at one time?
        </h6>
        <span class="faqAnswer">
          <b>Yes.</b> This can be done using the
          "{{ $nova.labelsName('access_management','commentary_bulk_level_ru_upload_label_tooltip','Bulk RU level upload') }}"
          option under Access Management.
          Please refer to the "Access Management" section in the User Manual for more details.
        </span>
      </div>
    </template>
  </lb-drawer>
</template>

<script>
export default {
  name: 'FaqDrawer',
  props: {
    value: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  computed: {
    localFaqDialog: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); }
    }
  }
}
</script>